<div class="theme-toggle-wrapper d-flex align-items-center">
  <mat-icon class="state-icon" [class.active]="!isDark()" aria-hidden="true">light_mode</mat-icon>

  <button
    type="button"
    class="custom-switch position-relative d-flex align-items-center"
    role="switch"
    [class.checked]="isDark()"
    [attr.aria-checked]="isDark()"
    [attr.aria-label]="'backoffice.common.theme_toggle.aria' | translate"
    (click)="toggle()"
  >
    <span class="switch-track w-100 h-100"></span>
    <span class="switch-thumb position-absolute"></span>
  </button>

  <mat-icon class="state-icon" [class.active]="isDark()" aria-hidden="true">dark_mode</mat-icon>
</div>
